(function() {
  'use strict';

  angular.module('ringbaPortal').directive('trTrueFalse', trTrueFalse);

  function trTrueFalse() {
    const directive = {
      restrict: 'E',
      transclude: true,
      scope: {
        status: '<'
      },
      template: '<i ng-if="status" class="true typcn typcn-tick"></i><i ng-if="!status" class="false typcn typcn-times">'
    };
    return directive;
  }
})();
